<div class="rk-ui-notification err" *ngIf="erroralert" style="z-index: 10000;">
  <span id="notificationMessageText">{{errorMessage}}</span>
  <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>
<div class="rk-ui-notification" *ngIf="successalert" style="z-index: 10000;">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="rk-ui-notification err" *ngIf="siteValidation_alert" style="z-index: 10000;">
  <span id="notificationMessageText">{{siteValidation_msg}}</span>
  <a class="close rk-linknotification" (click)="siteValidation_alert=false">×</a>
</div>
<!-- Site Measurement -->
<div class="row mt-4 right-section site-section">
  <div class="col-md-12">
    <button type="button" *ngIf="project_id" class="btn btn-pink pull-right" data-toggle="modal" data-target="#siteModal">
      CREATE REQUEST
    </button>
  </div>
  <div class="col-md-12 mt-5 text-center p-5" style="background-color: #fff;" *ngIf="siteRequestList.length <= 0">
    <!-- <i class="fa fa-trash trash-card" (click) = "deleteObject(obj.id)" *ngIf="role =='community_manager'" ></i> -->
    <img src="../../../assets/img/nothing.png" />
  </div>
  <div class="col-md-12 mt-5">
    <div class="row">
      <div class="col-md-12 mt-4">
        <div class="tableDiv table-responsive" *ngIf="siteRequestList.length > 0">
          <table class="table">
            <thead>
              <tr>
                <th class="firstTh">#</th>
                <th style="min-width: 200px;">Request Type</th>
                <th style="min-width: 56px;">Docket</th>
                <th style="min-width: 200px;">Request Status</th>
                <th style="min-width: 200px;">Address</th>
                <th style="min-width: 200px;">Scheduled At</th>
                <th style="min-width: 200px;">Rescheduled At</th>
                <th style="min-width: 200px;">Project</th>
                <th style="min-width: 200px;" class="lastTh">Sitesupervisor Assigned</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let obj of siteRequestList; let i = index ">
                <td>{{i+1}}</td>
                <td (click)="getGallery(obj.id, obj.remark)" class="btn-link"> {{obj.request_type | replaceChar}} </td>
                <td  class="text-center"> <img *ngIf="obj.request_type == 'Site_validation'" class="cursor-pointer" src="../../../../assets/img/docketIocn.png"  (click)="modalopenFiles(obj.id)" /></td>
                <td> {{obj.request_status | replaceChar}} </td>
                <td> {{obj.address}} </td>
                <td> {{obj.scheduled_at | date:'dd MMMM, y , h:mm a'}} </td>
                <td> {{obj.rescheduled_at | date:'dd MMMM, y , h:mm a'}} </td>
                <td> {{obj.project.name}} </td>
                <td>
                  <span *ngIf="obj.sitesupervisor">{{obj.sitesupervisor.name}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- CREATE SITE MODAL -->
<div class="modal fade" id="siteFilesModal" tabindex="-1" role="dialog" data-backdrop="static"  aria-labelledby="siteModalLabel" aria-hidden="true">
  <div class="modal-dialog modal_upload" role="document">
    <div class="modal-content">
      <div class="modal-header" style="border-bottom: 1px solid #e4e4e4;">
        <h6 class="modal-title pl-3" id="siteModalLabel">Files Upload </h6>
        <button *ngIf="!loading" type="button" class="close" data-dismiss="modal" (click)="clearFileUplaod()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div  class="col-sm-12 hh" (click)="file.click()" >
          <input type="file" #file class="custom-checkbox-input inputfile clearField" multiple (change)="uploadFile($event,1)"
             style="display: none;"  
            (click)="file.value = null">
          <label class="labelOfFile" for="file">Click Here to Upload FIles
          </label>
        </div>
        <span *ngIf="images?.length > 0 " class="ml-3 maxImgStyle">Files Uploaded</span>
        <ng-container *ngFor="let urlval of this.images;let i = index">
          <div class="col-md-6 previeHeadStyle  mt-3">
            <div class="col-8 pl-0">
              <span class=" maxImgStyle">{{imageName[i] | slice:0:30}}</span>
            </div>
            <div class="col-4 cancelStyle">
              
              <span class="ml-2 fileSizeStyle" (click)="onCancelMaxImages(i)"><i class="fa fa-close" style="color: rgba(0, 0, 0, 0.7); font-size:10px; cursor: pointer;"></i></span>
            </div>
          </div>
        </ng-container>

        <div class="col-12   ">
          <label>
            Remark
          </label>
          <textarea [(ngModel)]="remarkFile"  name="" class="form-control col-6" id="" cols="25" placeholder="Enter Remark" rows="5"></textarea>
        </div>
        <div  class="col-12 d-flex justify-content-center mt-3">
          <button class="btn w-15 btn-pink" (click)="UploadFilesSubmit()" [disabled]="checkValidation()  ">
            <i class="fa fa-spinner fa-spin"
            *ngIf="loading"></i>      Upload
          </button>
        </div>
<!-- 
        <table class="ZohoMapTable w-100 mt-3 ">

          <thead>
            <th class="minwidthZoho">
            Uploaded By 
            </th>
            <th class="minwidthZoho">
            Uploaded Date
              </th>
            <th class="minwidthZoho">
             View
            </th>
            <th class="minwidthZoho">
              Remarks
             </th>
          </thead>
  
          <tbody>
  
            <tr *ngFor="let data  of fileListingData; let i = index;">
              <td class="minwidthZoho">
               {{data.created_by_name}} <span class="text-capitalize" >({{(data.created_by_role | replaceChar)}})</span>
              </td>
              <td class="minwidthZoho" >
                {{data.files[0]?.created_at?(data.files[0]?.created_at | date:'dd-MM-yyyy'):''}}

              </td>
              <td class="minwidthZoho p-1">
                <ng-container *ngFor="let file of data.files"> 
                  <div>
                    <a href="{{file.site_image}}" class="text-info" target="_blank">{{file.id}}</a>
                    <span *ngIf ="data.can_delete">
                      <i class="fa ml-2 fa-spinner fa-spin"
                      *ngIf="loading && DeleteFileId == file.id "></i> <i *ngIf="DeleteFileId != file.id " (click) = "Deletefile(file.id , file.site_validation_remark_id)" class="fa fs_16 fa-close ml-2 cursor-pointer"></i>
                    </span>
                  </div>
                </ng-container>
              </td>
              <td class="minwidthZoho">
               {{data.remark}}
              </td>
            </tr>
  
          </tbody>
  
        </table> -->
        <div *ngFor ="let data of fileListingData ; let i = index"  class="mt-3 w-75">
          <div style="background-color: #f7f7f7;" class="mb-3" *ngIf ="data && data.files">
            <div class="pt-2 px-3">
              <p class="mb-1">{{data.created_by_name}} ({{data.created_by_role | replaceChar}})</p>
              <p class="mb-1 text-uploaded">Uploaded a File</p>
            </div>
            <div>
              <div class="row">
                  <div class="col-6">
                    <div *ngFor ="let file of data.files ; let z = index">
                      <div class=" pb-2 px-3">
                        <a href="{{file.site_image}}" target="_blank" class="mb-0 text-info fileName">{{file.id}}
                        <span class="ml-1">
                          <img src="../../../../assets/img/fileiconblack.png">
                        </span>
                        </a>
                      
                        <span *ngIf ="data.can_delete">
                          <i class="fa ml-2 fa-spinner fa-spin"
                          *ngIf="loading && DeleteFileId == file.id "></i> <i *ngIf="DeleteFileId != file.id " (click) = "Deletefile(file.id , file.site_validation_remark_id)" class="fa fs_16 fa-close ml-2 cursor-pointer"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 align-self-center col-6 d-flex justify-content-end px-4 mb-0 fileName">
                    <p *ngIf ="data.files"> {{data.files[0]?.created_at?(data.files[0]?.created_at | date:'dd-MM-yyyy h:mm a'):''}}</p>
                  </div>
              </div>
          
            </div>
           
          </div>

          <div *ngIf ="data.remark" style="background-color: #f7f7f7;" class="fileName">
            <p class="mb-0 px-3 py-2">{{data.created_by_name}} ({{data.created_by_role | replaceChar}})</p>

            <div class="">
              <p class="mb-0 pl-3 px-1 py-2 w-100 ">{{data.remark}}</p>
              <p class=" mb-0 mx-2 text-right">{{data.created_at | date:'dd-MM-yyyy h:mm a' }}</p>
            </div>
          </div>
        </div>



       
        
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="siteModal" tabindex="-1" role="dialog" aria-labelledby="siteModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header" style="border-bottom: 1px solid #e4e4e4;">
        <h6 class="modal-title" id="siteModalLabel">Create a site measurement request : </h6>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <form [formGroup]="createRequestForm" (ngSubmit)="onRequest()" class="form-horizontal" enctype="multipart/form-data">
              <div class="form-group">
                <label for="request_type" class="ss-form-label">Request Type</label>
                <select class="form-control ss-form-control" formControlName="request_type" id="request_type">
                  <option value="null" disabled="true" [selected]="true">Select request type</option>
                    <option *ngFor = "let data of request_type_data" value="{{data}}">{{data | replaceChar}}</option>
                </select>
                <label for="address" class="ss-form-label mt-4">Address</label>
                <textarea class="form-control ss-form-control" id="address" name="address" rows="5" placeholder="Please enter the address of site" formControlName="address"></textarea>

                <label for="scheduled_at" class="ss-form-label mt-4">Date and Time</label>
                <input type="datetime-local" class="form-control ss-form-control" name="scheduled_at" id="scheduled_at" formControlName="scheduled_at">

                <button type="submit" class="btn btn-pink button_emi pull-right mt-4" [disabled]="!createRequestForm.valid" > Submit </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- View Gallery MODAL -->
<div class="modal fade" id="viewGalleryModal" tabindex="-1" role="dialog" aria-labelledby="completeRequestModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header" style="border-bottom: 1px solid #e4e4e4;">
        <h6 class="modal-title" id="completeRequestModalLabel">Gallery : </h6>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row m-0">
          <div class="col-sm-12"><strong>Remarks:</strong></div>
          <div class="col-sm-12 remarks" style="border-bottom: 1px solid #bbb;"></div>
          <div class="col-sm-12 text-center" *ngIf="imageGallery.length <= 0">
            No Image available
          </div>

          <div class="col-md-4 mt-4" *ngFor="let item of imageGallery">
            <div class="card card-chng">
              <i class="fa fa-trash trash-card" (click) = "deleteObject(item.id)" *ngIf="role =='community_manager'" ></i>
              <img onerror="this.src='./assets/img/no_image.svg';" class="card-img-top img-fluid" src="{{item.site_image}}" alt="Card image cap" style="max-height: 165px;" />
              <div class="card-block" style="padding: 1rem;">
                <div class="row">
                  <div class="col-md-12">
                    <p class="mb-0 mt-2" style="font-size:13px;">
                      <span>Uploaded at: </span>
                      <span style="color: #7E7E7E;">{{item.updated_at | date:'dd MMMM, y - h:mm a'}}</span>
                    </p>
                  </div>
                  <div class="col-md-12 divbutton mt-2">
                    <a class="btn btn-pink btn-chng pull-right" href="{{item.site_image}}" download>
                      Download
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/lead/files-site-measurement/files-site-measurement.component.html